module.exports = __webpack_public_path__ + "assets/magnifying-glass.7643063b.svg";